<template>
  <div>
    <b-card>
      <div class="d-flex justify-content-between">
        <div class="mr-auto">
          <h6>联系人</h6>
        </div>
        <div>
          <a v-b-toggle.collapse-contacts role="button" style="color: #606266">
            <i v-if="isContacts" class="fa fa-chevron-down" title="收起"></i>
            <i v-else class="fa fa-chevron-up" title="展开"></i>
          </a>
        </div>
      </div>
      <b-collapse v-model="isContacts" id="collapse-contacts">
        <vxe-grid
          class="mt-3"
          ref="table"
          round
          auto-resize
          highlight-hover-row
          :height="tableHeight"
          :data="tableData"
          :columns="tableColumn"
          :loading="loading"
          :seq-config="{}"
        >
          <template v-slot:toolbar_form>
            <slot name="header"> </slot>
          </template>
          <template v-slot:pager>
            <slot name="pager"></slot>
          </template>
          <template v-slot:defaultImgUrl="{ row }">
            <div v-viewer="{ movable: true }">
              <el-image
                :src="
                  row.scmImageUrl
                    ? $osscdn(row.scmImageUrl)
                    : '/image/static/img/nopic.jpg'
                "
                style="width:100px; height:66px"
              >
                <div slot="error" class="image-slot">
                  <img
                    src="/image/static/img/nopic.jpg"
                    style="width: 100px; height: 66px"
                  />
                </div>
              </el-image>
            </div>
          </template>
          <template v-slot:contactName="{ row }">
            <span style="font-size: 14px; color: #666666;font-weight:600">{{
              row.contactName
            }}</span>
            <br />
            <span style="font-size: 12px; color: #606266">{{
              row.contactJob
            }}</span>
          </template>
          <template v-slot:contactPhone="{ row }">
            <i
              class="fa fa-mobile ml-1"
              style="font-size: 20px; color: #606266"
            />
            <span style="font-size: 14px; color: #606266" class="ml-2">{{
              row.contactMobile
            }}</span>
            <br />
            <i class="fa fa-phone" style="font-size: 16px; color: #606266" />
            <span style="font-size: 14px; color: #606266" class="ml-2">{{
              row.contactPhone
            }}</span>
          </template>
          <template v-slot:contactEmail="{ row }">
            <i
              class="fa fa-envelope-o"
              style="font-size: 16px; color: #606266"
            />
            <span style="font-size: 14px; color: #606266" class="ml-2">{{
              row.contactEmail
            }}</span>
          </template>
          <template v-slot:empty="{}">
            <div style="text-align: center">
              <img src="/image/static/img/nodata.png" />
              <p class="no-data">暂无数据！</p>
            </div>
          </template>
        </vxe-grid>
      </b-collapse>
    </b-card>
  </div>
</template>
<script>
import SwiperCore, { Navigation, Pagination, Scrollbar } from 'swiper'
SwiperCore.use([Navigation, Pagination, Scrollbar])
export default {
  components: {},
  props: {
    params: {
      default: null,
      type: Object
    },
    autoLoad: {
      default: false,
      type: Boolean
    }
  },
  watch: {
    params: {
      handler() {
        if (this.autoLoad) {
          this.init(this.params)
        }
      },
      deep: true,
      immediate: true
    }
  },
  data() {
    return {
      isContacts: true,
      loading: false,
      swiperOption: {
        slidesPerView: 3,
        spaceBetween: 30,
        freeMode: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        speed: 500,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      },
      tableHeight: 267,
      tableData: [],
      tableToolbar: {},
      tableColumn: [
        {
          field: 'seq',
          width: 50,
          align: 'center',
          type: 'seq'
        },
        {
          field: 'contactName',
          width: 170,
          title: '联系人',
          slots: { default: 'contactName' }
        },
        {
          field: 'contactPhone',
          width: 220,
          title: '电话',
          slots: { default: 'contactPhone' }
        },
        {
          field: 'contactEmail',
          minWidth: 200,
          title: '邮箱',
          slots: { default: 'contactEmail' }
        }
      ]
    }
  },
  mounted() {},
  beforeDestroy() {},
  methods: {
    init(params) {
      this.getData(params)
    },
    getData(params) {
      this.loading = true
      let page = {
        curPage: 1,
        pageSize: 100
      }
      this.$api
        .opaScmContactsListApi({ ...params, ...page })
        .then((res) => {
          this.loading = false
          this.tableData = res.body.data
        })
        .catch(() => {
          this.loading = false
        })
    }
  }
}
</script>
<style lang="scss" scoped>
//   @import './base.scss';

.swiper-slide {
  width: 80%;
}
.swiper-slide:nth-child(2n) {
  width: 60%;
}
.swiper-slide:nth-child(3n) {
  width: 40%;
}

.swiper-button-next {
  right: 10px;
  margin-top: -2.4rem;
  width: 2.4rem;
  height: 2.4rem;
  border-radius: 100%;
  opacity: 0.3;

  &:hover {
    opacity: 0.9;
  }

  &::after {
    content: none;
  }
}

.swiper-button-prev {
  left: 10px;
  margin-top: -2.4rem;
  width: 2.4rem;
  height: 2.4rem;
  border-radius: 100%;
  opacity: 0.3;

  &:hover {
    opacity: 0.9;
  }

  &::after {
    content: none;
  }
}

.icon-font {
  font-size: 2.2rem;
}

.card {
  margin: 20px 10px;
}
</style>
